import { useMediaQuery, useTheme } from '@mui/material'

/**
 * 基準はタブレット(大きいサイズ)で、一定のサイズ以下になったらスタイルを変更する
 */

export type Breakpoint = 'mobile' | 'tablet' | 'pc'

export const useBreakpoint = (): Breakpoint => {
  const theme = useTheme()
  const isSmartphone = useMediaQuery(theme.breakpoints.only('mobile'))
  const isTablet = useMediaQuery(theme.breakpoints.only('tablet'))

  if (isSmartphone) {
    return 'mobile'
  } else if (isTablet) {
    return 'tablet'
  }

  return 'pc'
}
